import type {ColSpec} from "~/components/table/MithraTableHeadColumns.tsx";

export const TARGET_COLUMNS: Array<ColSpec> = [
    {cls: '', txt: 'Title', columnFieldId: 'title', minWidth: 240},
    {cls: '', txt: 'Owner', columnFieldId: 'owner__email'},
    // Category / Company are many-to-many, so not orderable.
    {cls: '', txt: 'Category'},
    {cls: '', txt: 'Company'},
    {cls: '', txt: 'Start date', columnFieldId: 'start_date'},
    {cls: '', txt: 'Target year', columnFieldId: 'target_year'},
    {cls: '', txt: 'Cost saving', columnFieldId: 'saving_amount'},
]
